import { createGoogleMeetApiCall, disconnectGoogleMeetApiCall, googleMeetCheckIfProviderConnectedApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const GOOGLE_MEET_CHECK_IF_CONNECTED = { entity: 'GOOGLE_MEET_CHECK_IF_CONNECTED', action: Action.GET_ONE };
export const CREATE_GOOGLE_MEET = { entity: 'CREATE_GOOGLE_MEET', action: Action.CREATE };
export const DISCONNECT_GOOGLE_MEET = { entity: 'DISCONNECT_GOOGLE_MEET', action: Action.DELETE };

export const googleMeetCheckIfConnected = () => async dispatch =>
  execute(dispatch, () => googleMeetCheckIfProviderConnectedApiCall(), GOOGLE_MEET_CHECK_IF_CONNECTED, false);

export const createMeet = (start, end, description) => async dispatch =>
  execute(dispatch, () => createGoogleMeetApiCall({ start, end, description }), CREATE_GOOGLE_MEET);

export const disconnectGoogleMeet = () => async dispatch => execute(dispatch, () => disconnectGoogleMeetApiCall(), DISCONNECT_GOOGLE_MEET);

export const googleMeetReducers = {
  isConnected: basicReducer(GOOGLE_MEET_CHECK_IF_CONNECTED),
  disconnect: basicReducer(DISCONNECT_GOOGLE_MEET),
};
